module.exports = __webpack_public_path__ + "static/media/gls_leg_r.91256dfb.png";